var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`mt-1 text-${_vm.size} text-red-500 flex flex-row gap-2`},[_c('font-awesome-icon',{staticClass:"my-auto",attrs:{"icon":['far', 'exclamation-circle']}}),(_vm.error)?_c('span',[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }